import Helper from "../Helper";

export default class PaginationArrows {

  /**
   * @param {Element} wrapper
   * @constructor
   */
    constructor(wrapper)
    {
        this.backButton = $(wrapper).find('[data-backward]');
        this.forwardButton = $(wrapper).find('[data-forward]');
        this.buttonsWrapper = $(wrapper);

        this.elementsWrapper = document.querySelector('[data-paginationelements="'+$(wrapper).data('elementsWrapperId')+'"]');
        this.elementScrollLeftBefore = 0;

        // their width will always be 243
        this.allElementsWidth = ($(this.elementsWrapper).find('[data-paginationcounter]').length) * 243;
        this.possibleScrollWidth = this.allElementsWidth - $(this.elementsWrapper).width();

        this.distance = 2000;
        this.step = 35;
        // the less the faster
        this.speed = 20;

        this.jump = 2;

        this.init();
    }

    init()
    {
        $(document).ready(() => {
          /**
           * On window resize
           */
            window.windowResizeObserve.register(() => {
                this.showOrHideArrows();
            });

        this.showOrHideArrows();
        this.backButton.hide();

        $(this.backButton).on('click', () => {
            this.sideScroll('left');
          });

        $(this.forwardButton).on('click', () => {
            this.sideScroll('right');
          });

        $(this.elementsWrapper).on('scroll', (e) => {
            this.handleShowingArrowsOnSwipe();
          })
        })
    }


  /**
   * Function that horizontally slides an element
   *
   * @param {String} direction left or right
   */
    sideScroll(direction)
    {
        let scrollAmount = 0;

        let slideTimer = setInterval(() => {

            if (direction === 'left') {
                this.elementsWrapper.scrollLeft -= this.step;
            } else {
                this.elementsWrapper.scrollLeft += this.step;
            }

            scrollAmount += this.step;

            if (scrollAmount >= this.distance) {
                window.clearInterval(slideTimer);
            }
        }, this.speed);
    }

  /**
   * Function that shows or hides arrows
   */
    showOrHideArrows()
    {
        this.possibleScrollWidth = this.allElementsWidth - $(this.elementsWrapper).width();

        if (this.allElementsWidth >= $(this.elementsWrapper).width() && !Helper.isMobileOrLower()) {
            this.buttonsWrapper.show();
        } else {
            this.buttonsWrapper.hide();
        }
    }

  /**
   * Function that handles 'scroll' event on wrapper
   */
    handleShowingArrowsOnSwipe()
    {
        let elementScrollLeftNew = $(this.elementsWrapper).scrollLeft();

        if (this.elementScrollLeftBefore < elementScrollLeftNew) {
            this.backButton.show();

            if (elementScrollLeftNew >= this.possibleScrollWidth) {
                this.forwardButton.hide();

                $(this.buttonsWrapper).css({
                    'justify-content': 'flex-start'
                });
            } else {
                $(this.buttonsWrapper).css({
                    'justify-content': 'space-between'
                });
            }
        } else {
            this.forwardButton.show();

            if (elementScrollLeftNew === 0) {
                this.backButton.hide();

                $(this.buttonsWrapper).css({
                    'justify-content': 'flex-end'
                });
            } else {
                $(this.buttonsWrapper).css({
                    'justify-content': 'space-between'
                });
            }
        }

        this.elementScrollLeftBefore = elementScrollLeftNew;
    }
}